import React from 'react';
import { Outlet } from 'react-router-dom';
import HomeRedesignNav from '../pages/home-redesign/HomeRedesignNav';
import HomeRedesignFooter from '../pages/home-redesign/HomeRedesignFooter';

/** Persistent shell — nav/footer stay mounted across client-side route changes. */
const ChismePageLayout: React.FC = () => {
  return (
    <div className="min-h-screen bg-[#fcf7fa] font-jakarta text-[#2a0f2a] antialiased">
      <HomeRedesignNav />
      <main>
        <Outlet />
      </main>
      <HomeRedesignFooter />
    </div>
  );
};

export default ChismePageLayout;
